import React from 'react';

const TableLimitSelector = ({ limit, onLimitChange }) => {
    if (!limit || !onLimitChange) return null;
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <label htmlFor="table-limit" style={{ fontSize: '0.875rem', color: '#4b5563', fontWeight: '500' }}>Records per page:</label>
            <select
                id="table-limit"
                value={limit}
                onChange={(e) => onLimitChange(Number(e.target.value))}
                style={{
                    padding: '6px 12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    backgroundColor: 'white',
                    color: '#374151',
                    fontSize: '0.875rem',
                    outline: 'none',
                    cursor: 'pointer',
                }}
            >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
            </select>
        </div>
    );
};

export default TableLimitSelector;
